// extracted by mini-css-extract-plugin
var _1 = "UbExV";
export { _1 as "base" }
